
import { FooterSection as NewFooter } from '@/components/ui';

export default function Footer() {
  return <NewFooter />;
} 